import { render, staticRenderFns } from "./InviteAccountDialog.vue?vue&type=template&id=5c433732&scoped=true"
import script from "./InviteAccountDialog.vue?vue&type=script&lang=ts"
export * from "./InviteAccountDialog.vue?vue&type=script&lang=ts"
import style0 from "./InviteAccountDialog.vue?vue&type=style&index=0&id=5c433732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c433732",
  null
  
)

export default component.exports